import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import { useLocalStorage } from 'react-use';
import AuditorVisitationAnswerInput from '../Widget/Visitation/Auditor/Input.js';
import AuditorVisitationAnswerFormula from '../Widget/Visitation/Auditor/Formula.js';
import AuditorVisitationAnswerTable from '../Widget/Visitation/Auditor/Table.js';
import {Loading} from 'components/Loading/loading';
import { useHistory, useParams } from 'react-router-dom';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import {
  Alert,
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from 'react-bootstrap';
import FormRepository from 'repository/Form.js';
import natsort from 'hooks/natsort.js';

export default function Admin() {

  const history = useHistory();
	const { formId, employeeId } = useParams();
  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert(null);

  const [form, setForm] = useState(null);
  const [isFilterFailed, setIsFilterFailed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [time, setTime] = useState(Date.now());
  const [timeLoad, setTimeLoad] = useState(5000);
	const [schedule, setSchedule] = useState();
  const [criteria, setCriteria] = useState();
  const [answers, setAnswers] = useState([]);
  const [scores, setScores] = useState([]);
  const [auditeeTeams, setAuditeeTeams] = useState([]);
  const [actionTypes, setActionTypes] = useState([]);

  const repository = new FormRepository(auth.token);

  const handleSubmit = async () => {
    try {

      const onSuccessCallback = async () => {

        const data = {
          VISIT_AT: moment().format('DD-MM-YYYY hh:mm:ss'),
          VISIT_BY: auth.employee.EMP_ID,
        };

        const response = await repository.update(formId, data);

        history.push(`/auditor/${employeeId}/audits/${schedule.SCHEDULE_ID}/visitations`);

      }

      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Confirmation!`,
          message: `Are you sure to submit?`,
          onSuccess: {
            title: `Success`,
            message: `Submit Success`,
            callback: onSuccessCallback,
          }
        }
      });

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const fetchForm = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}forms/${formId}`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          expand: `
          criteria,
          answers.answerAttachments,
          answers.question,
          answers.index,
          answers.answerActions.pics.employee,
          answers.answerActions,
          schedule.instrument.score.scoreIndices,
          schedule.auditeeTeams,
          schedule.auditeeTeams.employee,
          schedule.auditee.department
          `.trim(),
        }
      });


      const {criteria, answers, schedule, ...rest} = response.data;
      setForm(rest);
      setSchedule(response.data.schedule);
      setCriteria(response.data.criteria);
      setAnswers(response.data.answers.sort((a, b) => natsort(a.question.QUESTION_CODE, b.question.QUESTION_CODE)));
      setScores(response.data.schedule.instrument.score.scoreIndices);
      console.log('INi adalah score');
      console.log(response.data.schedule.instrument.score.scoreIndices);
      setAuditeeTeams(response.data.schedule.auditeeTeams);
      const type_table = [];
      response.data.answers.map((answer) => {
        if(answer.question.QUESTION_TYPE_ID == 3){
          type_table.push('3');
        }
      })

      if(type_table.length > 20){
        setTimeout(() => {
          document.body.style.zoom = "85%"
          setIsLoading(false)
          console.log("Time : ", Date.now()-time);
          const body = document.querySelector('#root');
          body.scrollIntoView({
            behavior: 'smooth'
          }, 200)
        }, 50000);
      }else if(type_table.length > 13){
        setTimeout(() => {
          document.body.style.zoom = "85%"
          setIsLoading(false)
          console.log("Time : ", Date.now()-time);
          const body = document.querySelector('#root');
          body.scrollIntoView({
            behavior: 'smooth'
          }, 200)
        }, 39000);
      }else if(type_table.length > 10){
        setTimeout(() => {
          document.body.style.zoom = "85%"
          setIsLoading(false)
          console.log("Time : ", Date.now()-time);
          const body = document.querySelector('#root');
          body.scrollIntoView({
            behavior: 'smooth'
          }, 200)
        }, 22000);
      }else if(type_table.length > 5){
        setTimeout(() => {
          document.body.style.zoom = "85%"
          setIsLoading(false)
          console.log("Time : ", Date.now()-time);
          const body = document.querySelector('#root');
          body.scrollIntoView({
            behavior: 'smooth'
          }, 200)
        }, 13000);
      }else if(type_table.length > 0){
        setTimeout(() => {
          document.body.style.zoom = "85%"
          setIsLoading(false)
          console.log("Time : ", Date.now()-time);
          const body = document.querySelector('#root');
          body.scrollIntoView({
            behavior: 'smooth'
          }, 200)
        }, 8000);
      }
      else{
        document.body.style.zoom = "85%"
        setIsLoading(false)
      }

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleClickDept = async (e) => {
    e.preventDefault();
    const path = history.location.pathname;
    const myArray = path.split("/");
    if(myArray[1] == 'auditor'){
      return history.push(`/auditor/${auth.employee.EMP_ID}/audits/${schedule.SCHEDULE_ID}/visitations`)
    }else{
      return history.push(`/admin/audits/${schedule.SCHEDULE_ID}/visitations`)
    }
  }

  const handleClickAudits = async (e) => {
    e.preventDefault();
    const path = history.location.pathname;
    const myArray = path.split("/");
    if(myArray[1] == 'auditor'){
      return history.push(`/auditor/${auth.employee.EMP_ID}/audits`)
    }else{
      return history.push(`/admin/schedules`)
    }
  }

  const handleLoading = () => {
    console.log("Ini handle Loading");
    setIsLoading(false);
  }

  const fetchActionType = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}action-types`, {
        params: {all: true},
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });

      setActionTypes(response.data.items);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const renderSubmitStatus = () => {

    switch (true) {
      case !form:
        return null;
      case Boolean(form.VISIT_BY && form.VISIT_AT):
        return <Alert variant="info" style={{textAlign: 'center'}}>This form already submitted for visitation.</Alert>;
      case Boolean(form.EVALUATE_AT && form.EVALUATE_BY):
        return (
          <Row style={{ justifyContent: 'flex-end' }}>
            <Col style={{ width: 'auto', flexGrow: 'unset', flexBasis: 'unset' }}>
              <Button onClick={handleSubmit} variant="success">Submit</Button>{' '}
            </Col>
          </Row>
        );
    }

    return <Alert variant="warning" style={{textAlign: 'center'}}>Evaluation is in progress.</Alert>;
  }

  useEffect(() => {
		fetchForm();
    fetchActionType();
    setTime(Date.now());
    document.body.style.zoom = "100%"
	}, []);

  useEffect(() => {
  }, [isFilterFailed]);

  // setTimeout(() => {
  //   setIsLoading(false)
  //   console.log("Time : ", Date.now()-time);
  //   const body = document.querySelector('#root');
  //   body.scrollIntoView({
  //     behavior: 'smooth'
  //   }, 20)
  // }, timeLoad);

  // useEffect(() => {
  //   window.addEventListener("load",handleLoading);
  //   return () => window.removeEventListener("load",handleLoading);
  // }, [isLoading]);


  return (
    <Container fluid>
      {swal}
      <Modal
        show={isLoading}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Loading />
      </Modal>
      <Breadcrumb>
        <Breadcrumb.Item onClick={handleClickAudits}>
          Audit
        </Breadcrumb.Item>
        <Breadcrumb.Item onClick={handleClickDept}>
          { schedule && schedule.auditee.department.DEPT_NAME}
        </Breadcrumb.Item>
        <Breadcrumb.Item aria-current="page" active>
          Visitation
        </Breadcrumb.Item>
      </Breadcrumb>

      {criteria && (
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title style={{fontWeight:'bold'}} as="h3">{criteria.CRITERIA_CODE}. {criteria.CRITERIA_LABEL}</Card.Title>
              </Card.Header>
              <Card.Body>
                <div style={{whiteSpace: 'pre-wrap', fontSize:'17px'}} dangerouslySetInnerHTML={{__html: criteria.CRITERIA_DESCRIPTION}} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* <Row>
        <Col md="12">
          <Form.Group>
            <p>Show Failed Only</p>
            <Form.Check
              value={isFilterFailed}
              onChange={({target: {value}}) => setIsFilterFailed(value)}
              type="switch"
              id="custom-switch-11"
              className="mb-1"
            />
          </Form.Group>
        </Col>
      </Row> */}



      {answers && schedule && scores.length > 0 && answers
        .map((answer, key) => {
          switch (answer.question.QUESTION_TYPE_ID) {
            case 1:
              return <AuditorVisitationAnswerInput key={key} scores={scores} answer={answer}
              actionTypes={actionTypes} auditeeTeams={auditeeTeams} scheduleId={schedule.SCHEDULE_ID} />;
            case 2:
              return <AuditorVisitationAnswerFormula key={key} scores={scores} answer={answer}
              actionTypes={actionTypes} auditeeTeams={auditeeTeams} scheduleId={schedule.SCHEDULE_ID} />;
            case 3:
              return <AuditorVisitationAnswerTable key={key} scores={scores} answer={answer}
              actionTypes={actionTypes} auditeeTeams={auditeeTeams} scheduleId={schedule.SCHEDULE_ID}/>;
          }
        })
        // .filter(answer =>  {
        //   if (isFilterFailed) {
        //     return isFilterFailed && answer.answerActions?.find(action => action.ANSWER_ID === answer.ANSWER_ID)
        //   }

        //   return true;
        // })
      }
      {renderSubmitStatus()}
      {/* {hanyaCheck()} */}
    </Container>
  )
}